import { render, staticRenderFns } from "./ScheduleOfFees.vue?vue&type=template&id=83d69378"
import script from "./ScheduleOfFees.vue?vue&type=script&lang=js"
export * from "./ScheduleOfFees.vue?vue&type=script&lang=js"
import style0 from "./ScheduleOfFees.vue?vue&type=style&index=0&id=83d69378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports